<template>
  <section class="page">
    <template v-if="faqCategory">
      <div class="page__header">
        <SharedBreadcrumbs :breadcrumbs />

        <h1 class="typography__headline1" v-html="faqCategory.name" />

        <FaqSearch />
      </div>

      <FaqArticlesList :articles="faqCategory.articles" />
    </template>
  </section>
</template>

<script lang="ts" setup>
const { t, locale } = useI18n();

import FaqArticlesList from "~/components/entities/faq/FaqArticlesList.vue";

const route = useRoute();

const { item: faqCategory } = await useGetFaqCategoryApi({
  fetchOptions: {
    params: {
      slug: Array.isArray(route.params.slug) ? route.params.slug[0] : route.params.slug,
      locale: locale.value
    },
  },
});

if (faqCategory.value === null) {
  throw createError({
    fatal: true,
    statusCode: 404,
  });
}

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/" + locale.value + "/faq",
  },
  {
    name: faqCategory.value.name,
  },
];

useSeoMeta({
  title: () => {
    return faqCategory.value?.name ?? "";
  },
});

definePageMeta({
  layout: "faq",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

@media (--md) {
  .page {
    row-gap: 80px;
  }
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}
</style>
